import { Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/SystemType/SystemTypeModel';
import { RootState } from '../../../store';
import SystemTypeForm from '../SystemTypeForm/SystemTypeForm';

const InfoDeviceModal: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxSystemType = useSelector((state: RootState) => state.models.systemType);

  return (
    <Modal
      title={!!reduxSystemType.id ? 'Modifica' : 'Adauga'}
      open={reduxSystemType.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <SystemTypeForm />
    </Modal>
  );
};

export default InfoDeviceModal;
